import SpecialPlans from '@/components/PricingPlan/SpecialPlans'
import { info_icon } from 'constant/AllIcons'
import { pricing_plans } from 'data/PringPlanData'
import Link from 'next/link'
import React from 'react'
import Faqs from '../Faqs'
import FeaturesTable from '../FeaturesTable'
import {
  MixpanelEventName,
  MixpanelPropertiesName,
  MixpanelPropertiesValues,
  MixpanelTracking,
} from 'constant/mixpnael'
import { getAuthKey } from 'constant/functions'
import { useGetPlansQuery } from '@/redux/features/plans/plansApi'
import { getFormattedPrice } from '@/utils/getFormattedPrice'

const SMEPricing = ({ is_annual, userDetails, tenantDetails }) => {
  const { data: plan_resp } = useGetPlansQuery()

  return (
    <div className=" grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-[11px]">
      {pricing_plans?.map((item, index) => {
        const plan = plan_resp?.plans?.find(
          (p) =>
            p.name.includes(item.id) &&
            (is_annual ? p.recurring_type === 'yearly' : p.recurring_type === 'monthly')
        )

        return (
          <div
            className={
              item?.is_show_star
                ? 'relative flex flex-col h-full py-5 px-6 rounded    shadow-xl border-2 border-blue-500'
                : 'relative flex flex-col h-full py-5 px-6 rounded bg-white shadow-xl '
            }
            data-aos="zoom-y-out"
            data-aos-delay="450"
          >
            {item?.is_show_star && (
              <div className="absolute top-0 right-0 mr-5 p-3 -mt-5 bg-yellow-500 rounded-full">
                <svg
                  className="w-4 h-4 fill-current text-white"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M15.145 5.05l-4.316-.627L8.898.513c-.338-.684-1.456-.684-1.794 0l-1.93 3.91-4.317.627a1.002 1.002 0 00-.554 1.707l3.124 3.044-.737 4.3a1 1 0 001.45 1.053L8 13.125l3.862 2.03c.728.381 1.59-.234 1.45-1.054l-.736-4.299L15.7 6.758a1.003 1.003 0 00-.555-1.708z" />
                </svg>
              </div>
            )}
            <div className="mb-4">
              <div className="text-2xl font-bold mb-1">{item?.title}</div>
              <div className="inline-flex items-baseline mb-1">
                {plan ? (
                  <span className="text-[2em] font-bold">
                    {getFormattedPrice({ currency_code: plan.currency, amount: plan.amount })}
                  </span>
                ) : (
                  <span className="text-[2em] font-bold">
                    {item?.price?.dollar_sign}
                    {is_annual ? item.price.true : item.price.false}
                  </span>
                )}
                <span className="text-gray-900 pl-2">/{item.price.title}</span>
              </div>
              <p className=" text-lightGray text-sm font-medium">per month</p>
              <p className=" text-lightGray text-sm font-medium">
                {is_annual ? 'billed yearly' : 'billed monthly'}
              </p>
              <div className="text-lg text-gray-900 mt-4">{item?.description}</div>
            </div>
            <ul className="text-gray-900 -mb-2 flex-grow">
              {item?.features?.map((feature) => {
                return (
                  <li className="flex items-center justify-between mb-2">
                    <div className="flex items-center  ">
                      <svg
                        className="w-3 h-3 fill-current text-green-500 mr-3 flex-shrink-0"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      {feature?.link ? (
                        <Link href={feature?.link}>
                          <a className="underline">{feature?.title}</a>
                        </Link>
                      ) : (
                        <span>{feature?.title}</span>
                      )}
                    </div>
                    {feature?.info && (
                      <div className="ml-1 group">
                        <span className=" cursor-pointer">{info_icon}</span>
                        <span className=" hidden  absolute group-hover:block bg-gray-600 text-gray-50 text-sm  mt-2 text-start p-2 z-20 rounded-md max-w-xs w-full right-0">
                          {feature?.info}
                        </span>
                      </div>
                    )}
                  </li>
                )
              })}
            </ul>
            <div className="border-t border-gray-200 pt-5 mt-6">
              <a
                className="btn-sm !py-[9px] text-white bg-blue-900 hover:bg-blue-700 w-full"
                href={item.link}
                onClick={() => {
                  MixpanelTracking(MixpanelEventName.pricing_page, {
                    [MixpanelPropertiesName.user_name]: userDetails?.name,
                    [MixpanelPropertiesName.user_email]: userDetails?.email,
                    [MixpanelPropertiesName.tenant_name]: tenantDetails?.id,
                    [MixpanelPropertiesName.pricing_page_action]: MixpanelPropertiesValues.buy_now,
                  })
                  getAuthKey() === undefined && localStorage.setItem('selected_plan', item.id)
                }}
              >
                {index == 0 ? 'Start Building For Free' : 'Start 7 Days Trial'}
              </a>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default SMEPricing
